import React from 'react'
import { idEmpresa } from "../../constans/constants";
import {
    obtenerTipoTramite, setTipoTramite, importarPlantilla,
    modificarTipoTramite, obtenerPlantilla, obtenerTiposFormularios,
    obtenerAccionesColaborador
} from '../tramites/TipoTramiteService.js';
import BreadCrumComponent from '../../components/componentes/BreadCrumComponent';
import DropzoneComponent from "../componentes/DropzoneComponent";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from '../mensajeFlash/PantallaCarga.js';
import {
    mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
    integrarConHandleInput
} from '../../constans/form-error-utils';
import AparienciaFirma from "../tiposDocumento/AparienciaFirma";

class NuevoTipoTramite extends React.Component {
    constructor(props) {
        super(props);


        const { tipoAccion } = props.match.params;

        const originalHandleInput = this.handleInput;

        this.handleInput = integrarConHandleInput(this, originalHandleInput);

        this.state = {
            dialogTitle: "Registrar nuevo tipo de tramite",
            dialogType: "add",
            submitText: "Guardar",
            disabledInput: false,
            formulariosTipoTramite: [],
            accionesColaborador: [],
            accionColaborador: "",
            formularioId: null,
            archivoPlantilla: null,
            archivoNombre: "",
            pesoArchivoMb: "",
            cantidadFirmas: null,
            errors: {
                formularioId: null,
                archivoPlantilla: null,
                cantidadFirmas: null,
                accionColaborador: null
            },
            showErrors: false,
            isCronJobActive: false,
            remindDaysAfterPublish: 0,
            remindFrecuencyDays: 0,
            remindFrecuencyHours: 0,
            remindFrecuencyMinutes: 0,
            mostrarMensajeFlash: false,
            mensajeFlash: "",
            mensajeFlashSeverity: "neutral",
            openPantallaCarga: false,
            id: null,
            tipoAccion,
            titulo: null,
            continuarAparienciaFirma: false,
            formatoFirmaSolicitante: "",
        };
    }

    async componentDidMount() {

        configurarLimpiezaAutomatica()

        obtenerTiposFormularios().then((res) => {
            if (!res.error) {
                this.setState({
                    formulariosTipoTramite: res.datos,
                })
            } else {
                this.setState(prevState => ({
                    errors: {
                        ...prevState.errors,
                        formularioId: res.mensaje
                    }
                }))
            }
        })

        obtenerAccionesColaborador().then((res) => {
            if (!res.error) {
                this.setState({
                    accionesColaborador: res.tipFirmaEmpleado,
                })
            } else {
                this.setState(prevState => ({
                    errors: {
                        ...prevState.errors,
                        accionesColaborador: "No se pudieron recuperar los datos"
                    }
                }))
            }
        })

        if (this.state.tipoAccion === "edit") {
            const { tipoTramite } = this.props.location.state;
            obtenerTipoTramite(tipoTramite.id).then((res) => {
                if (res.error != null) {
                    this.setState({
                        id: tipoTramite.id,
                        formularioId: res.datos.tipoFormularioTramite.codigoRegistro,
                        cantidadFirmas: res.datos.cantidadFirmas,
                        accionColaborador: res.datos.accionesColaborador.codigo,
                        isCronJobActive: res.datos.cronJobActive,
                        remindDaysAfterPublish: res.datos.remindDaysAfterPublish,
                        remindFrecuencyDays: res.datos.remindFrecuencyDays,
                        remindFrecuencyHours: res.datos.remindFrecuencyHours,
                        remindFrecuencyMinutes: res.datos.remindFrecuencyMinutes,
                        formatoFirmaSolicitante: res.datos.formatoFirmaSolicitante,
                        editar: true,
                        titulo: "Datos del tipo solicitud: " + tipoTramite.nombre
                    });
                    if (res.datos.fileUid != null) {
                        obtenerPlantilla(res.datos.fileUid).then((res) => {
                            if (!res.error) {
                                this.handleDownload(res.datos.nombre, res.datos.archivo);
                            } else {
                                this.setState(prevState => ({
                                    errors: {
                                        ...prevState.errors,
                                        archivoPlantilla: res.mensaje
                                    }
                                }))
                            }
                        })
                    }

                } else {
                    this.setState({
                        mostrarMensajeFlash: true,
                        mensajeFlash: res.mensaje,
                        mensajeFlashSeverity: "danger"
                    })
                }

            });
        }
    }

    formatFileSize = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + sizes[i];
    }

    handleArchivo = (archivo) => {
        this.setState({ archivoPlantilla: archivo, archivoNombre: archivo.name, pesoArchivoMb: this.formatFileSize(archivo.size) })
    }


    handleDownload = (filename, base64) => {

        const byteCharacters = atob(base64);

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: 'application/octet-stream' });

        this.setState({ archivoPlantilla: blob, archivoNombre: filename })
    }

    handleInput = (e) => {
        const name = e.target.name;
        const val = e.target.value;
        this.setState(prevState => ({
            errors: {
                ...prevState.errors,
                [name]: null
            },
            [name]: val,
        }))
    };

    validarFormulario = () => {
        let isValid = true
        let errors = {
            formularioId: null,
            archivoPlantilla: null,
            cantidadFirmas: null
        }
        
        if (this.state.archivoPlantilla === null) {
            errors.archivoPlantilla = "Debe subir una plantilla"
            isValid = false
        }
        
        if (this.state.cantidadFirmas === null || this.state.cantidadFirmas < 0) {
            errors.cantidadFirmas = "El tramite debe llevar al menos una firma"
            isValid = false
        }
        if (this.state.formularioId === null) {
            errors.formularioId = "Debe seleccionar un formulario"
            isValid = false
        }
        if (this.state.accionColaborador === "") {
            errors.accionColaborador = "Debe seleccionar una opcion"
            isValid = false
        }


        return { errors, isValid }

    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { errors, isValid } = this.validarFormulario();
        if (isValid) {
            mostrarErroresEnFormulario({});
            if (this.state.archivoPlantilla != null)
                this.setState({ continuarAparienciaFirma: true })
            else
                this.setState({
                    mostrarMensajeFlash: true,
                    mensajeFlash: "Debe agregar una plantilla .jrxml para la solicitud",
                    mensajeFlashSeverity: "advertencia",
                })
        } else {
            this.setState({ errors: errors, showErrors: true });
            mostrarErroresEnFormulario(errors);
        }
    };

    signSolicitante = (sign) => {
        this.setState({ formatoFirmaSolicitante: sign });
    };

    handleGuardarConApariencia = () => {
        let data = {
            id: "",
            codigoRegistro: this.state.formularioId,
            empresaId: idEmpresa(),
            cantidadFirmas: this.state.cantidadFirmas,
            accionesColaborador: this.state.accionColaborador,
            isCronJobActive: this.state.isCronJobActive,
            remindDaysAfterPublish: this.state.remindDaysAfterPublish,
            remindFrecuencyDays: this.state.remindFrecuencyDays,
            remindFrecuencyHours: this.state.remindFrecuencyHours,
            remindFrecuencyMinutes: this.state.remindFrecuencyMinutes,
            formatoFirmaSolicitante: this.state.formatoFirmaSolicitante,
        };
        this.guardarTramite(data);
    };

    guardarTramite = (data) => {
        this.setState({ openPantallaCarga: true });
        if (this.state.tipoAccion == "edit") {
            data.id = this.state.id;
            modificarTipoTramite(data).then(res => {
                if (!res.error) {

                    let id = res.datos.id;
                    let plantilla = new FormData();
                    plantilla.append("file", this.state.archivoPlantilla);
                    plantilla.append("filename", this.state.archivoNombre);
                    importarPlantilla(plantilla, id).then(response => {
                        this.props.history.push({
                            pathname: `/configuracion/tipo-solicitud`,
                            state: {
                                mensajeFlash: response.mensaje,
                                mostrarMensajeFlash: true,
                                mensajeFlashSeverity: response.error ? "error" : "exito",
                            }
                        });
                    })

                } else {
                    this.setState({
                        mostrarMensajeFlash: true,
                        mensajeFlash: res.mensaje,
                        mensajeFlashSeverity: "error",
                        openPantallaCarga: false
                    })
                }
            })

        } else {
            setTipoTramite(data).then(res => {
                if (!res.error) {
                    let id = res.datos.id;
                    let plantilla = new FormData();
                    plantilla.append("file", this.state.archivoPlantilla);
                    plantilla.append("filename", this.state.archivoNombre);
                    importarPlantilla(plantilla, id).then(response => {
                        this.props.history.push({
                            pathname: `/configuracion/tipo-solicitud`,
                            state: {
                                mensajeFlash: response.mensaje,
                                mostrarMensajeFlash: true,
                                mensajeFlashSeverity: response.error ? "error" : "exito",
                            }
                        });
                    })
                } else {
                    this.setState({
                        mostrarMensajeFlash: true,
                        mensajeFlash: res.mensaje,
                        mensajeFlashSeverity: "error",
                        openPantallaCarga: false
                    })
                }
            })
        }
    }

    handleBotonCancelar = () => {
        this.props.history.push('/configuracion/tipo-solicitud')
    }

    handleChecked = (event) => {
        let name = event.target.name;
        let val = event.target.checked;

        if (!val) {
            this.setState({
                [name]: val,
                remindDaysAfterPublish: 0,
                remindFrecuencyDays: 0,
                remindFrecuencyHours: 0,
                remindFrecuencyMinutes: 0
            });

        } else {
            this.setState({
                [name]: val,
            });
        }
    }


    renderFormulario = () => {
        return (
            <div>
                <div className="template-base">
                    <header className="component-header">
                        <div className="page-container">
                            <BreadCrumComponent
                                backUrl='/configuracion/tipo-solicitud'
                                breadcrumbs={
                                    [
                                        { label: 'Tipos de solicitudes', path: '/configuracion/tipo-solicitud' },
                                        {
                                            label: this.props.match.params.tipoAccion !== 'edit'
                                                ? "Registrar nuevo tipo solicitud"
                                                : "Editar tipo solicitud", path: ''
                                        }
                                    ]
                                }
                            />
                            <div className="head-area">
                                <div className="caption-area">
                                    <h1 className="page-title"> {this.state.titulo ?? "Registrar nuevo tipo de solicitud"}  </h1>
                                    <p className="page-description"> Complete el siguiente formulario con los datos solicitados </p>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div className="wrapperContent">
                        <div className="page-container">
                            <div className="component-form">
                                <div className="page-container">
                                    <div className="component-content card">
                                        <form onSubmit={this.handleSubmit} className="form container-sm">
                                            <div className="form-group__inline">
                                                <div className="form-group">
                                                    <select className="form-select" name="formularioId" id="formularioId" placeholder=" " value={this.state.formularioId} onChange={this.handleInput}>
                                                        <option value=""> </option>
                                                        {this.state.formulariosTipoTramite.map((elemento) => (
                                                            <option key={elemento.id} value={elemento.codigoRegistro}>
                                                                {elemento.nombreFormulario}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <label htmlFor="formularioId" className="form-label"> Formulario </label>
                                                </div>
                                                <div>
                                                    <div className="form-group">
                                                        <input type="number" min={1} name="cantidadFirmas" id="cantidadFirmas" className="form-input" placeholder=" " value={this.state.cantidadFirmas} onChange={this.handleInput} />
                                                        <label htmlFor="cantidadFirmas" className="form-label"> Cantidad de firmas </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <select className="form-select" placeholder=" " name="accionColaborador" id="accionColaborador" value={this.state.accionColaborador} onChange={this.handleInput} >
                                                    <option value=""> </option>
                                                    {this.state.accionesColaborador.map((elemento) => (
                                                        <option key={elemento.codigo} value={elemento.codigo}>
                                                            {elemento.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor="accionColaborador" className="form-label"> Acciones del colaborador </label>
                                            </div>

                                            <hr />

                                            <span className="form-subtitle"> Recordatorio </span>

                                            <div className="form-group">

                                                <input type="checkbox" className="form-check" name="isCronJobActive" id="isCronJobActive" onChange={this.handleChecked} value={this.state.isCronJobActive} />
                                                <label htmlFor="cronJobActive" className="check-label"> Enviar Recordatorio a los firmantes </label>

                                                {this.state.isCronJobActive &&

                                                    <div className="form-group__inline">
                                                        <div className="form-group">
                                                            <input type="number" min={1} name="remindDaysAfterPublish" id="remindDaysAfterPublish" className="form-input" onChange={this.handleInput} value={this.state.remindDaysAfterPublish} />
                                                            <label htmlFor="remindDaysAfterPublish" className="form-label"> Días a partir de publicación </label>
                                                        </div>

                                                        <div className="form-group">
                                                            <input type="number" min={0} name="remindFrecuencyDays" id="remindFrecuencyDays" className="form-input" value={this.state.remindFrecuencyDays} onChange={this.handleInput} />
                                                            <label htmlFor="remindFrecuencyDays" className="form-label"> Días </label>
                                                        </div>

                                                        <div className="form-group">
                                                            <input type="number" min={0} name="remindFrecuencyHours" id="remindFrecuencyHours" className="form-input" value={this.state.remindFrecuencyHours} onChange={this.handleInput} />
                                                            <label htmlFor="remindFrecuencyHours" className="form-label"> Horas </label>
                                                        </div>

                                                        <div className="form-group">
                                                            <input type="number" min={0} name="remindFrecuencyMinutes" id="remindFrecuencyMinutes" className="form-input" value={this.state.remindFrecuencyMinutes} onChange={this.handleInput} />
                                                            <label htmlFor="remindFrecuencyMinutes" className="form-label"> Minutos </label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <hr />

                                            <span className="form-subtitle"> Subir Plantilla </span>

                                            <div className="container-flex center-content">
                                                <div className="col">
                                                    <div className="form-group" name="archivoPlantilla">
                                                        <div className="carga-documento-section">
                                                            <DropzoneComponent onFileSelected={this.handleArchivo} archivos_soportados={["jrxml"]} />
                                                        </div>
                                                    </div>
                                                    {this.state.archivoPlantilla && (
                                                        <div className="component-progress-upload">
                                                            <div className="contentInner">
                                                                <div className="icon-shape shape-xl">
                                                                    <span className="material-symbols-outlined">folder_zip</span>
                                                                </div>
                                                                <div className="progress-content">
                                                                    <div className="load-info">
                                                                        <span className="file-name">{this.state.archivoNombre}</span>
                                                                    </div>
                                                                    <div className="file-info">
                                                                        <span className="file-size">{this.state.pesoArchivoMb}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                </div>
                                            </div>

                                            <div className="form-actions">
                                                <button onClick={() => this.handleBotonCancelar()} className="btn-medium btn-link"> Cancelar </button>
                                                <button type="submit" className="btn-medium btn-primary"> GUARDAR </button>
                                            </div>

                                        </form>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <PantallaCarga open={this.state.openPantallaCarga} />
                    <MensajeFlash
                        visible={this.state.mostrarMensajeFlash}
                        mensaje={this.state.mensajeFlash}
                        severity={this.state.mensajeFlashSeverity}
                        onAutoClose={() => this.setState({ mostrarMensajeFlash: false })}
                    />
                </div>
            </div>
        )
    }

    renderPantallaAparienciaFirma = () => {
        return (
            <AparienciaFirma
                isFirmaEmpresa={false}
                isFirmaColaborador={true}
                labelColaborador="Solicitante"
                backUrl="/configuracion/tipo-solicitud"
                breadcrumbLabel="Tipos de solicitudes"
                firmaEmpresa={() => { }}
                firmaEmpleado={this.signSolicitante}
                aparienciaEmpleado={this.state.formatoFirmaSolicitante}
                handleClose={this.handleGuardarConApariencia}
                editar={this.state.editar}
                disabledInput={false}
            />
        );
    }

    render() {
        if (this.state.continuarAparienciaFirma) {
            return this.renderPantallaAparienciaFirma();
        }
        return this.renderFormulario();
    }
}

export default NuevoTipoTramite;
